import { effect } from "@preact/signals";
import * as preact from "preact";

import readlangClient from "readlangClient";
import RemoteUserWordsStore from "stores/RemoteUserWordsStore";

interface Props {
  model: RemoteUserWordsStore;
}

interface State {
  visible: boolean;
  numDeleted: number;
  deletedDate: string | null;
}

class UndoDeleteView extends preact.Component<Props, State> {
  state: State = { visible: false, numDeleted: 0, deletedDate: null };

  disposeSelectionEffect?: () => void;
  disposeWordsDeletedEffect?: () => void;
  disposeSearchQueryChange?: () => void;

  componentDidMount() {
    this.disposeWordsDeletedEffect = effect(() => {
      const wordsDeleted = this.props.model.wordsDeleted.value;
      if (wordsDeleted) {
        this.onWordsDeleted(wordsDeleted);
      }
    });
    this.disposeSearchQueryChange = this.props.model.onSearchQueryChange(
      this.hide
    );
    this.disposeSelectionEffect = effect(() => {
      void this.props.model.selectionStore.count.value;
      this.hide();
    });
  }

  componentWillUnmount() {
    this.disposeWordsDeletedEffect?.();
    this.disposeSearchQueryChange?.();
    this.disposeSelectionEffect?.();
  }

  onWordsDeleted = (options: { numDeleted: number; deletedDate: string }) => {
    this.setState({
      visible: true,
      numDeleted: options.numDeleted,
      deletedDate: options.deletedDate,
    });
  };

  hide = () => {
    if (this.state.visible) this.setState({ visible: false });
  };

  undoDelete = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    const { deletedDate } = this.state;
    this.setState({ visible: false });

    readlangClient.request(
      "PATCH",
      "/api/userWords/unDelete",
      { deletedDate },
      () => {
        this.props.model.reFetch();
      }
    );
  };

  render() {
    if (!this.state.visible) {
      return (
        <div
          class="wordListNotification undoDelete"
          style={{ display: "none" }}
        />
      );
    }
    const numDeleted = this.state.numDeleted;
    return (
      <div class="wordListNotification undoDelete" style={{ display: "block" }}>
        {`${numDeleted} ${numDeleted === 1 ? "word" : "words"} deleted.`}{" "}
        <a href="#" class="undoDelete" onClick={this.undoDelete}>
          Undo
        </a>
      </div>
    );
  }
}

export default UndoDeleteView;
